import * as types from './mutations-types'

export const setSnackMessage = ({ commit }, message) => {
  commit(types.SET_SNACK_MESSAGE, message)
}

export const setFilters = ({ commit }, message) => {
  commit(types.SET_FILTERS, message)
}

export const increaseInitCount = ({ commit, state }) => {
  commit(types.UPDATE_INIT_COUNT, state.initCount + 1)
}
